import CardStatementDetailsWithPermissions from "modules/CardStatement/lib/CardStatementDetailsWithPermissions";
import { memo } from "react";
function CorporateStatementDetailsPage() {
  return <CardStatementDetailsWithPermissions cardFormat={"corporate"} />;
}

export default memo(CorporateStatementDetailsPage);
